import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import WorkOutlineIcon from '@mui/icons-material/WorkOutline';
import CheckCircleOutlineOutlinedIcon from '@mui/icons-material/CheckCircleOutlineOutlined';
import TonalityOutlinedIcon from '@mui/icons-material/TonalityOutlined';
import { Grid, Skeleton, Stack } from '@mui/material';
import { useSelector } from 'react-redux';

export default function PlacementCards() {
  const placementTrackerAnalyticsTableCards = useSelector(
    (state) => state.general.placementTrackerAnalyticsTableCards.data,
  );
  const placementTrackerAnalyticsTableCardsLoading = useSelector(
    (state) => state.general.placementTrackerAnalyticsTableCards.loading,
  );

  const cards = [
    { id: 1, label: 'Intern Batches', value: 'totalBatches', icon: <PeopleAltIcon /> },
    { id: 2, label: 'Total Interns', value: 'totalInterns', icon: <WorkOutlineIcon /> },
    // { id: 3, label: 'Total Active Batches', value: 10, icon: <PublishedWithChangesIcon /> },
    { id: 4, label: 'Placed Students', value: 'totalTutors', icon: <CheckCircleOutlineOutlinedIcon /> },
    { id: 5, label: 'Incomplete Students', value: 'totalWaitingForPlacement', icon: <TonalityOutlinedIcon /> },
  ];
  /*       {
            "totalBatches": 1,
            "totalStudents": 1,
            "totalTrackers": 1,
            "totalWaitingForPlacement": 0,
            "totalInterns": 0,
            "totalTutors": 1,
            "totalEmployees": 0,
            "totalRejected": 0
        } */

  return (
    <Box display={'flex'} gap={2}>
      {placementTrackerAnalyticsTableCardsLoading ? (
        <Grid container spacing={2} mb={4}>
          {cards.map((e, i) => (
            <Grid item xl={2} lg={3} sm={6} md={4} xs={12} key={i}>
              <Skeleton height={150} />
            </Grid>
          ))}
        </Grid>
      ) : (
        <Grid container spacing={2} mb={4}>
          {cards.map(({ id, label, value, icon }) => (
            <Grid item xl={2} lg={3} sm={6} md={4} xs={12} key={id}>
              <Stack
                gap={2}
                borderRadius={2}
                key={id}
                sx={{
                  background: 'linear-gradient(90deg,rgba(40, 162, 227, 1) 0%, rgba(13, 68, 116, 1) 100%)',
                  color: 'white',
                  height: '100%',
                  width: '100%',
                }}
                p={3}
              >
                <Box display={'flex'} gap={1} bgcolor={'#D9D9D938'} p={1} borderRadius={1} width={'100%'}>
                  {icon}
                  <Typography fontWeight={800}>{label}</Typography>
                </Box>
                <Typography textAlign={'center'} fontWeight={800}>
                  {placementTrackerAnalyticsTableCards?.[0]?.[value] ?? 0}
                </Typography>
              </Stack>
            </Grid>
          ))}
        </Grid>
      )}
    </Box>
  );
}
